import React from 'react';

import { FavoriteMatchesMenuState } from '../../types';
import { TournamentMenuItem } from 'app/modules/Navigation/types';

import { useTranslation } from 'app/lang';
import Layer from 'app/modules/LeftMenu/components/Layer';

import Matches from './Matches';
import Tournaments from './Tournaments';

import dictionary from './FavoritesMenuLayer.dictionary.json';

import styles from '../../styles/LeftMenu.module.scss';

export type FavoritesMenuLayerProps = {
  visible: boolean;
  tournaments: TournamentMenuItem[];
  matches: FavoriteMatchesMenuState;
  location: string;
};

const FavoritesMenuLayer: React.FC<FavoritesMenuLayerProps> = ({
  visible,
  tournaments,
  matches,
  location,
}) => {
  const { t } = useTranslation();
  return (
    <Layer level="1"
           header={{ title: t(dictionary.title), location }}
           visible={visible}>
      <ul className={styles.layerMenuItems}>
        <Tournaments list={tournaments} />

        <Matches menu={matches} />
      </ul>
    </Layer>
  );
};

export default FavoritesMenuLayer;
